import ReactPDF, { View, Page, Text, StyleSheet, Font, Image, Link } from "@react-pdf/renderer";
import { styles } from "./pdfstyles";
import { riskLevel } from "../components/AnalyseCalc";
import { DangerRow } from "./DangerRow";
import { TiAData } from "../components/TiA";

export default function TiAPDF(pdf: TiAData) {

    Font.register({
        family: "Roboto",
        src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf"
    })

    const questionText = (checked: boolean, value?: string) => {

        return checked
            ? <Text>TAK, {value}</Text>
            : <Text>NIE</Text>
    }

    return (
        <ReactPDF.Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.title}>
                    <Image src="https://e-rodo.eu/images/ready/waga_naruszen.jpg" style={{height: "171px"}} />
                </View>
                <View style={styles.title}>
                    <Text>TiA</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>1) Kontekst transferu</Text>
                    <Text style={styles.header}>Podmiot przekazujący informacje?</Text>
                    <Text>{pdf.entityData}</Text>
                    <Text style={styles.header}>Jakiej operacji dotyczy transfer?</Text>
                    <Text>{pdf.operationType}</Text>
                    <Text style={styles.header}>Data rozpoczęcia operacji?</Text>
                    <Text>{pdf.transferDateStart}</Text>
                    <Text style={styles.header}>Data zakończenia operacji?</Text>
                    <Text>{pdf.transferDateEnd}</Text>
                    <Text style={styles.header}>Kategorie danych objęte operacją?</Text>
                    <Text>{pdf.transferCategories}</Text>
                    <Text style={styles.header}>Kategorie osób których dane są transferowane</Text>
                    <Text>{pdf.personalCategories}</Text>
                    <Text style={styles.header}>Cel operacji</Text>
                    <Text>{pdf.transferPurpose}</Text>
                    <Text style={styles.header}>Czy operacja wykorzystuje narzędzia TiA? Jakie?</Text>
                    <Text>{questionText(pdf.isToolTransfer, pdf.toolTransfer)}</Text>
                    <Text style={styles.header}>Format danych(np.: tekst, anonimizacja)</Text>
                    <Text>{pdf.dataFormat}</Text>
                    <Text style={styles.header}>Nazwa podmiotu</Text>
                    <Text>{pdf.entityName}</Text>
                    <Text style={styles.header}>Rola podmiotu</Text>
                    <Text>{pdf.entityRole}</Text>
                    <Text style={styles.header}>Rodzaj podmiotu</Text>
                    <Text>{pdf.entityStatus}</Text>
                    <Text style={styles.header}>Sektor podmiotu</Text>
                    <Text>{pdf.entitySector}</Text>
                    <Text style={styles.header}>Państwo, do którego transferujesz dane</Text>
                    <Text>{pdf.country3pp}</Text>
                    <Text style={styles.header}>Podstawa prawna transferu danych</Text>
                    <Text>{pdf.lawRule}</Text>
                    <Text style={styles.header}>Środki zabezpieczenia transferu</Text>
                    <Text>{pdf.wayOfTransfer}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>2) Prawo i praktyka</Text>
                    <Text style={styles.header}>Źródło wiedzy o systemie prawnym w kraju odbiorcy</Text>
                    <Text>{pdf.knowledgeSource}</Text>
                    <Text style={styles.header}>Czy w kraju są przepisy RODO?</Text>
                    <Text>{questionText(pdf.isCountryLaw, pdf.countryLaw)}</Text>
                    <Text style={styles.header}>Czy w kraju są respektowane przepisy RODO?</Text>
                    <Text>{questionText(pdf.isCountryEntity, pdf.countryEntity)}</Text>
                    <Text style={styles.header}>Czy kraj posiada niezależny organ nadzorczy odnośnie RODO?</Text>
                    <Text>{questionText(pdf.isCountryIndependent, pdf.countryIndependent)}</Text>
                    <Text style={styles.header}>Czy kraj jest zobowiązany międzynarodowo odnośnie RODO?</Text>
                    <Text>{questionText(pdf.isCountrySide, pdf.countrySide)}</Text>
                    <Text style={styles.header}>Czy przepisy są zgodne z UE?</Text>
                    <Text>{questionText(pdf.isLawCompatible, pdf.lawCompatible)}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>3) Służby specjalne a dane osobowe</Text>
                    <Text style={styles.header}>Czy dostęp do danych jest jasny i precyzyjny?</Text>
                    <Text>{questionText(pdf.isDataAvailability, pdf.dataAvailaibility)}</Text>
                    <Text style={styles.header}>Czy dostęp do danych jest niezbędny?</Text>
                    <Text>{questionText(pdf.isDataNecessary, pdf.dataNecessary)}</Text>
                    <Text style={styles.header}>Czy istnieje kontrola nad służbami specjalnymi?</Text>
                    <Text>{questionText(pdf.isControlTool, pdf.controlTool)}</Text>
                    <Text style={styles.header}>Czy istnieją środki ochrony osób?</Text>
                    <Text>{questionText(pdf.isWayOfProtect, pdf.wayOfProtect)}</Text>
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>4) Analiza ryzyka</Text>
                    <DangerRow name="Naruszenie" values={pdf.risks.map(x => x.name)} />
                    <DangerRow name="Prawdopodobieństwo" values={pdf.risks.map(x => x.probability)} />
                    <DangerRow name="Skutki" values={pdf.risks.map(x => x.effect)} />
                    <DangerRow name="Ryzyko" values={pdf.risks.map(x => riskLevel(x).text)} />
                </View>
                <View style={styles.panel}>
                    <Text style={styles.header}>5) Wynik testu</Text>
                    <Text style={styles.header}>Czy odbiorca danych zapewni europejski poziom ochrony?</Text>
                    <Text>{questionText(pdf.isWayOfProtection, pdf.wayOfProtection)}</Text>
                    <Text style={styles.header}>Decyzja administratora danych</Text>
                    <Text>{pdf.adminDecision}</Text>
                </View>
                <View style={styles.mt2}>
                    <Text style={styles.textTitle}>ZASTRZEŻENIE</Text>
                    <Text style={styles.text}>Wyniki podane przez kalkulator są orientacyjne i pomocnicze, nie mogą być jedyną podstawą do podejmowania działań ani do pełnej diagnozy stanu faktycznego. Nie ponosimy jakiejkolwiek odpowiedzialności za skutki uboczne korzystania z kalkulatora. Dodatkowe szczegóły w zakresie przepisów prawa: art. 24 i art. 32 RODO. Potrzebujesz pomocy? Skontaktuj się z nami i umów się na spotkanie.</Text>
                </View>
                <View>
                    <Text style={styles.textTitle}>WSPARCIE</Text>
                    <Text style={styles.text}>Wspieramy w zakresie ochrony danych i obsługi naruszeń ochrony danych oraz w ich klasyfikacji.</Text>
                </View>
                <View style={styles.center}>
                    <Link src="https://e-rodo.eu/kontakt.php#contact-section">
                        <Image src="https://e-rodo.eu/images/ready/PDF.jpg" style={{height: "171px"}} />
                    </Link>
                </View>
            </Page>
        </ReactPDF.Document>
    )
}

